import scratch from './scratch.vue'
export default scratch